<campus-video-player [videoId]="videoId" [player]="player" class="video"></campus-video-player>

<div>
  <h2 [attr.id]="anchor">{{ title }}</h2>

  <div class="text">
    <ng-content></ng-content>
  </div>

  <dcr-outline-button
    label="Meer info"
    trailing-icon="actions:trending_flat"
    target="_blank"
    [href]="readMoreLink"
  ></dcr-outline-button>
</div>
